import React from 'react'
import T from 'prop-types'

import Login from './components'
import { useAuth } from './useAuth'

const ProtectedRoute = ({
  children,
  authData,
  ProtectedTemplate = ({ children }) => <>{children}</>,
  LoginFlowTemplate = ({ children }) => <>{children}</>,
  ...props
}) => {
  const { currentSession, authEvent, userEnabled } = useAuth()

  const canSkipMFA = authEvent?.preferredMFA !== 'NOMFA'

  return (
    <>
      {currentSession && userEnabled && canSkipMFA ? (
        <ProtectedTemplate>{children}</ProtectedTemplate>
      ) : (
        <LoginFlowTemplate>
          <Login />
        </LoginFlowTemplate>
      )}
    </>
  )
}

export default ProtectedRoute

ProtectedRoute.propTypes = {
  children: T.node,
  authData: T.object,
}
